// Cookie consent (GH-1134): the SPA side of the landing's contract
// (pages/app-lending index.html, "COOKIE CONSENT"). Same storage key, record
// shape, window.dathentConsent and 'dathent:consent' event, so both sites
// mean the same thing by a choice.
//
// index.html's inline bootstrap sets Google Consent Mode to denied, applies a
// stored record before any tag loads, and maps every 'dathent:consent' event
// to gtag('consent', 'update', …). This module only records and publishes the
// visitor's choice; it never talks to Google itself.
//
// The landing (dathent.ai) keeps its record in its own origin's localStorage,
// which app.dathent.ai cannot read, so the app asks once on its own.

export const CONSENT_STORAGE_KEY = 'dathent-cookie-consent';
export const CONSENT_VERSION = 1;
export const CONSENT_EVENT = 'dathent:consent';

function browserWindow() {
  return typeof window !== 'undefined' ? window : undefined;
}

function storageOf(win) {
  try { return win?.localStorage ?? null; } catch { return null; }
}

function publicConsent(record) {
  return { necessary: true, analytics: !!record?.analytics, marketing: !!record?.marketing, raw: record || null };
}

/** The stored v1 record, or null (none, malformed, other version, blocked storage). */
export function readStoredConsent(storage) {
  try {
    const record = JSON.parse(storage?.getItem(CONSENT_STORAGE_KEY) ?? 'null');
    return record && record.v === CONSENT_VERSION ? record : null;
  } catch {
    return null;
  }
}

/** {necessary, analytics, marketing, raw} once the visitor has chosen, else null. */
export function currentConsent(win = browserWindow()) {
  try {
    if (win?.dathentConsent) return win.dathentConsent;
    const record = readStoredConsent(storageOf(win));
    return record ? publicConsent(record) : null;
  } catch {
    return null;
  }
}

/** Banner choice: 'accept' (analytics + marketing) or 'necessary'. Returns the published consent. */
export function saveConsentChoice(choice, win = browserWindow(), now = Date.now()) {
  const all = choice === 'accept';
  const record = { v: CONSENT_VERSION, necessary: true, analytics: all, marketing: all, ts: now };
  try { storageOf(win)?.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record)); } catch { /* this page still gets the choice */ }
  const consent = publicConsent(record);
  if (!win) return consent;
  win.dathentConsent = consent;
  try {
    const Event = win.CustomEvent || CustomEvent;
    win.document.dispatchEvent(new Event(CONSENT_EVENT, { detail: consent }));
  } catch { /* consent UI must never throw */ }
  return consent;
}
